import {useContext} from 'react';

import {UseOfContextWithoutProviderError} from '@/types/errors';
import {UserProfileContext} from './user-profile-context';

export const useUserProfileContext = () => {
  const context = useContext(UserProfileContext);

  if (!context) {
    throw new UseOfContextWithoutProviderError('UserProfileContext');
  }

  return context;
};
